import React, { useState } from "react";
import { Button } from "antd";
import { addAtmedCatalogAbroadStoryContent } from "../../../../store/actions";
import { PlusOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import PhotosCopy from "./PhotosCopy";
import { ATMED_VENDOR_CATALOG_ABROAD_HOME_STORIES } from "../../../../common/awsBucket";

const EditVendorEquipmentButton = ({ story }) => {
  const [imagemodalVisible, setimageModalVisible] = useState(false);

  const showImageModal = async () => {
    setimageModalVisible(true);
  };
  const hideImageModal = () => {
    setimageModalVisible(false);
  };

  const addPhoto = async (data) => {
    const payloadObj = {
      abroad_story_id: story.id,
      payload: {
        abroad_story_content: { url: data, media: "photo", status: true },
      },
    };

    addAtmedCatalogAbroadStoryContent(payloadObj);
  };

  return (
    <>
      <PhotosCopy
        data={story}
        surgery_id={story.surgery_id}
        onCancel={hideImageModal}
        visible={imagemodalVisible}
        title={story.title}
        submitText="Update content"
        addPhoto={addPhoto}
        uploadBucketName={ATMED_VENDOR_CATALOG_ABROAD_HOME_STORIES}
      />

      <div>
        <span>{story.content.length} Items</span>
      </div>
      <Button icon={<PlusOutlined />} type="primary" onClick={showImageModal}>
        VIEW / ADD
      </Button>
    </>
  );
};

const mapStateToProps = ({ catalogReducer }) => ({
  getAllCatalogAbroadStories: catalogReducer.getAllCatalogAbroadStories,
});
export default connect(mapStateToProps)(EditVendorEquipmentButton);
